/**
 * Форматирует числа в соответствии с локалью ru-RU
 *
 * также принимает остальные опции доступные в Number.toLocaleString
 * @example
 * // если привести к числу не удалось, по умолчанию выводится н/д
 * const deviation = numberFormatter({ source: undefined }) // н/д
 *
 * // н/д можно заменить на любой текст
 * const deviation = numberFormatter({ source: null, emptyText: 'нет данных' }) // нет данных
 *
 * // если в качестве `source` передана строка, она будет приведена к числу
 * const deviation = numberFormatter({ source: '100' }) // 100,0
 *
 * // precision влияет на количество знаков после запятой
 * const deviation = numberFormatter({ source: '100', precision: 0 }) // 100
 *
 * // suffix и prefix – текст перед и после значения соответственно
 * const deviation = numberFormatter({ source: '100', precision: 0, suffix: '%', prefix: '+' }) // +100%
 *
 * // для значений отклонений можно передать параметр kind: 'deviation'
 * const deviation = numberFormatter({ source: '0.3', suffix: '%', kind: 'deviation' }) // +0,3%
 */
export function numberFormatter({
  source,
  kind,
  precision = 1,
  emptyText = '-',
  suffix = '',
  prefix = '',
  locale = 'ru-RU',
  ...props
}: {
  source: string | number | null | undefined;
  suffix?: string;
  prefix?: string;
  precision?: number;
  emptyText?: string;
  kind?: 'deviation';
  locale?: string | string[];
} & Intl.NumberFormatOptions) {
  if (source === null || source === undefined || Number.isNaN(source)) {
    return emptyText;
  }

  let normalizedValue = typeof source === 'string' ? +source : source;

  if (!Number.isFinite(normalizedValue)) {
    return source as string;
  }

  if (Object.is(normalizedValue, -0)) {
    normalizedValue = Math.abs(normalizedValue);
  }

  let formattedValue = '';
  const options: Intl.NumberFormatOptions = {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
    ...props,
  };

  if (kind === 'deviation') {
    prefix = prefixBy(normalizedValue);
  }

  formattedValue = normalizedValue.toLocaleString(locale, options);

  if (locale.includes('en') && props.notation === 'compact') {
    formattedValue = formattedValue.replace(',', ' ').replace(/\./, ',');
  }

  return `${prefix}${formattedValue}${suffix}`;
}

function prefixBy(value: number) {
  return value > 0 ? '+' : '';
}

export function numberWithSpaces(x: number) {
  var parts = x.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return parts.join('.');
}
